import { generatePath } from 'react-router-dom';
import React from 'react';

import { type Routes } from '../types';

export default function useBuildRoute() {
  const of = React.useCallback(
    (
      path: '..' | '/' | Routes,
      options?: {
        // `string`, not `string | undefined`: a params bag holding an undefined
        // value makes `generatePath` throw `Missing ":x" param`. `of` runs
        // during RENDER — its result lands in a `to=` prop — so that throw
        // takes the whole page, not one dead control the way the click-handler
        // half did (Sentry MYFITWORLD-V2-6X). It used to be permitted here and
        // then cast away with `as any`, exactly as in `useNavigate`. For the
        // org-vs-personal decision use `orgAwareRoute`, which returns the path
        // and the matching params from one choice.
        params?: Record<string, string>;
        search?: string;
      },
    ) => {
      // the query string is appended AFTER the params are filled in: passing
      // `:param?query` to generatePath makes it read the trailing `?` as the
      // optional-param marker, so a path ENDING in a param came out unresolved
      // `<string>`, not inferred: see the same fix (and its rationale) in
      // `useNavigate.ts`.
      const generated = generatePath<string>(path, options?.params);

      return (
        options?.search ? `${generated}?${options.search}` : generated
      ) as Routes;
    },
    [],
  );
  return { of };
}
